import { Badge, IconButton } from "@mui/material";
import ChatIcon from "@mui/icons-material/Chat";
import { ChatBubbleOutline } from "@mui/icons-material";
import { Session } from "ezStore";
import { CommentFragment } from "__generated__/graphql/fragments.generated";
import { SVGIconProps } from "@cofano/cck/utils/componentAttributes";

interface CommentIndicatorButtonProps {
	entity: {
		id: number,
		comments: CommentFragment[],
	},
	session: Session,
	onClick?: () => void,
	color?: SVGIconProps["color"],
}

const CommentIndicatorButton = ({ entity, session, onClick, color }: CommentIndicatorButtonProps) => {

	const hasUnread = entity.comments.some(c => !session.readComments.comments.some(comment => comment.id === c.id) && c.created > session.readComments.date);

	return (
		<Badge
			onClick={e => {
				e.preventDefault();
				e.stopPropagation();

				if (onClick) {
					onClick();
				}
			}}
			color="error"
			variant={hasUnread ? "dot" : "standard"}
			style={{ display: "flex", alignItems: "center" }}
			sx={{
				"& .MuiBadge-badge": {
					top: "4px",
					right: "4px",
				},
			}}>
			<IconButton size="small">
				{entity.comments.length > 0
					? <ChatIcon fontSize="small" color={color} />
					: <ChatBubbleOutline fontSize="small" color={color} />}
			</IconButton>
		</Badge>
	);
};

export default CommentIndicatorButton;
